/* eslint-disable camelcase */
import { color, Common } from '@stockbit/ui';
import PollingContainer from 'global/StreamWidget/PollingContainer';
import DocumentContainer from 'global/StreamWidget/Post/DocumentContainer';
import RepostBox from 'global/StreamWidget/Post/RepostBox';
import RepostLabel from 'global/StreamWidget/Post/RepostLabel';
import TitleContent from 'global/StreamWidget/Post/TitleContent';
import TargetPriceContainer from 'global/StreamWidget/TargetPriceContainer';
import TextContent from 'global/StreamWidget/TextContent';
import Image from 'global/Image';
import YoutubePlayer from 'global/StreamWidget/Post/YoutubePlayer';
import { getYoutubeURL } from 'utils/stream';
import Footer from './Footer';
import {
  ContentWrapper,
  StreamContainer,
  CloseWrapper,
  PostContainer,
  FooterContainer,
  PostWrapper,
  StreamSkeleton,
  ImageSkeleton,
  HiddenLayerStreamConvo,
} from '../styled';
import TableSymbol from './TableSymbol';
import { StreamPostData } from '../../../../@types/stream';
import ImageDetail from './ImageDetail';
import Header from './Header';
import { ConversationDetailSizes } from 'hooks/useStreamConversationModal';

const { Iconmoon, Flex, Text } = Common;

interface DetailStreamProps {
  post: StreamPostData;
  topics: Array<any>;
  onCancel: () => any;
  isLoading?: boolean;
  handleClose: () => void;
  dimension: {
    width: ConversationDetailSizes,
    height: ConversationDetailSizes
  }
}

function DetailStream({
  post,
  onCancel,
  topics = [],
  isLoading = false,
  handleClose,
  dimension
}: DetailStreamProps) {
  const {
    content,
    content_original: contentOriginal,
    images,
    attachment,
    polling,
    target_price,
    mask_html,
    reposted,
    repostedfrom,
    title,
    titleurl,
    is_author: isAuthor,
  } = post;

  if (isLoading || Object.keys(post).length === 0) {
    return (
      <StreamContainer>
        <CloseWrapper onClick={onCancel}>
          <Iconmoon className="icon-compose_close" color={color.light} />
        </CloseWrapper>
        <PostContainer dimension={dimension}>
          <ImageSkeleton />
          <PostWrapper>
            <StreamSkeleton />
          </PostWrapper>
        </PostContainer>
      </StreamContainer>
    );
  }

  const youtubeUrl = getYoutubeURL(content);

  const hasImage = images.length > 0 && images[0] !== '';
  const hasYoutube = youtubeUrl !== null;
  const hasMediaContent = hasImage || hasYoutube;

  let contentWrapperHeight = 'calc(100% - 400px)';
  if (post.likes > 0 && hasMediaContent) {
    contentWrapperHeight = '130px';
  }

  if (post.likes === 0 && hasMediaContent) {
    contentWrapperHeight = '150px';
  }

  return (
    <StreamContainer>
      <HiddenLayerStreamConvo onClick={onCancel} />
      <CloseWrapper onClick={onCancel}>
        <Iconmoon className="icon-compose_close" color={color.light} />
      </CloseWrapper>
      <PostContainer dimension={dimension}>
        {hasImage && <ImageDetail src={images[0]} />}
        <PostWrapper>
          {/* HIDE REPOST LABEL FOR A WHILE AFTER BE IMPROVE THE PERFORMANCE */}
          {/* {reposted > 0 && <RepostLabel username={repostedfrom.username} />} */}
          <Header
            post={post}
            handleClose={handleClose}
          />
          <ContentWrapper height={contentWrapperHeight}>
            {polling.length > 0 ? (
              <PollingContainer post={post} isSinglePost />
            ) : (
              <>
                {title && titleurl && (
                  <TitleContent title={title} titleUrl={titleurl} />
                )}

                <TextContent content={content} maskedHtml={mask_html} />
                {!hasImage && <YoutubePlayer content={contentOriginal} />}

                {post.newsfeed_source && (
                  <Flex>
                    <Image
                      alt={post.newsfeed_label}
                      src={post.newsfeed_img}
                      style={{ width: '16px', marginRight: '8px' }}
                    />
                    <Text size="12px">{post.newsfeed_label}</Text>
                  </Flex>
                )}

                {attachment.length > 0 && (
                  <DocumentContainer documents={attachment} />
                )}

                {target_price.length > 0 && (
                  <TargetPriceContainer
                    targetPrice={target_price[0]}
                    postid={post.postid}
                    isAuthor={isAuthor}
                  />
                )}

                {reposted > 0 && <RepostBox post={repostedfrom} />}
              </>
            )}

            {topics?.length > 0 && (
              <TableSymbol topics={topics} postedDate={post.created_display} />
            )}
          </ContentWrapper>
          <FooterContainer>
            <Footer post={post} onComment={onCancel} />
          </FooterContainer>
        </PostWrapper>
      </PostContainer>
    </StreamContainer>
  );
}

export default DetailStream;
